/**
 * UAT-B4 — coach-only nav config (role-surfaces CD export §NAV `1b`).
 *
 * The reduced rail for coach-only accounts: Team · Meets · Settings.
 * Today/Train/Runs/Races-as-athlete mean nothing to a coach; Races is
 * re-pointed to `Meets` (SAME slot, SAME `/races` route — coach-only sees the
 * Team meets view there). Unlike the guardian rail, the coach rail keeps the
 * default SideNav variant: the "Ask a coach" elevated action + WorkspaceBadge
 * stay (a coach has both a team and the coach-aware chat entry).
 *
 * Approvals is reachable via the bell + the team page's "Needs you today"
 * strip — no new nav row (matches today's behaviour).
 */

export interface CoachNavItem {
  id: string;
  label: string;
  href: string;
  active?: boolean;
}

/** Build the coach SideNav item list. Pass the active item's id, or omit
 *  (e.g. on /approvals, reached via the bell — no coach nav row is active). */
export function coachNavItems(
  activeId?: 'team' | 'races' | 'settings' | null,
): CoachNavItem[] {
  return [
    { id: 'team', label: 'Team', href: '/team' },
    { id: 'races', label: 'Meets', href: '/races' },
    { id: 'settings', label: 'Settings', href: '/settings' },
  ].map((item) => (activeId && item.id === activeId ? { ...item, active: true } : item));
}
